import styled from 'styled-components';

export const Wrapper = styled.section`
  color: white;
  position: relative;
  min-height: 100vh;
  width: 100%;
  max-width: ${({ theme }) => theme.lgMax};
  padding-bottom: ${({ theme }) => theme.x4space}rem;
`;

export const CenteredHeading = styled.h4`
  text-align: center;
`;
